import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import { t } from '@lingui/core/macro'

export const LinkPreview = () => {
  const parameters = useSelector(state => state.Template.parameters)
  const fieldsById = useSelector(state => state.Template.fieldsById)

  function updatePreview() {
    const parts = []
    parameters.forEach(parameter => {
      const part = fieldsById[parameter.field_id]
        ? `[${fieldsById[parameter.field_id].name}]`
        : '[PARAMETER_VALUE]'
      const parameterName =
        parameter.name && parameter.name.trim().length ? parameter.name : '[PARAMETER]'
      parts.push(`${parameterName}=${part}`)
    })

    return `[domain]${parts.length ? '/?' : ''}${parts.join('&')}`
  }

  return (
    <div>
      <Typography variant="h5" style={{ textTransform: 'none' }}>
        <b>{t`Current configuration:`}</b> {updatePreview()}
      </Typography>
    </div>
  )
}
